function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { useCallback, useRef, useEffect } from 'react';

function usePersistFn(fn) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ref = useRef(function () {
    throw new Error('Cannot call an event handler while rendering.');
  });
  useEffect(function () {
    ref.current = fn;
  }, [fn].concat(_toConsumableArray(dependencies)));
  var persist = useCallback(function () {
    var refFn = ref.current;

    if (refFn) {
      return refFn.apply(void 0, arguments);
    }
  }, [ref]);

  if (typeof fn === 'function') {
    return persist;
  }

  return undefined;
}

export default usePersistFn;